import {Component, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {League} from "../../model/league";
import {LeaguesService} from "../../services/leagues.service";
import {MatDialog, MatDialogModule} from "@angular/material/dialog";
import {MatTableModule} from "@angular/material/table";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {RouterLink} from "@angular/router";
import {AsyncPipe, NgIf} from "@angular/common";
import {CreateLeagueDialogComponent} from "../create-league-dialog/create-league-dialog.component";

@Component({
  selector: 'app-admin-leagues',
  templateUrl: './admin-leagues.component.html',
  styleUrls: ['./admin-leagues.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    RouterLink,
    AsyncPipe,
    NgIf,
  ]
})
export class AdminLeaguesComponent implements OnInit {

  leagues$: Observable<League[]>;
  readonly columns = ['id', 'name', 'federation', 'poweredBy', 'licenced', 'archived', 'actions'];

  constructor(
    private leaguesService: LeaguesService,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    this.leagues$ = this.leaguesService.getAllLeagues();
  }

  createLeague(): void {
    this.dialog.open(CreateLeagueDialogComponent, {autoFocus: true});
  }

  archiveLeague(leagueId: string, archived: boolean): Promise<void> {
    return this.leaguesService.archiveLeague(leagueId, archived);
  }

  deleteLeague(leagueId: string): Promise<void> {
    return this.leaguesService.deleteLeague(leagueId);
  }
}
